import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const learningPaths = [
  ['Software foundations', 'Build confidence in practical programming, web systems, and the habits behind maintainable software.'],
  ['Applied AI and automation', 'Learn how to identify useful automation opportunities and turn them into responsible, testable workflows.'],
  ['Product delivery', 'Connect user needs, interface decisions, engineering, and release planning through project-based work.'],
];

export default function Academy() {
  useEffect(() => {
    document.title = 'Nalexus Academy | Practical Technology Learning';
  }, []);

  return (
    <main id="main-content" className="sync-main sync-subpage">
      <section className="sync-page-hero sync-academy-hero sync-section">
        <div className="sync-shell sync-page-hero-grid">
          <div>
            <p className="sync-eyebrow">Nalexus Academy</p>
            <h1>Learn technology by building things that work.</h1>
          </div>
          <div>
            <p className="sync-lead">Practical learning paths for institutions, teams, and early-career technologists—grounded in real workflows and project delivery.</p>
            <Link className="sync-button" to="/contact?intent=academy">Ask about current availability</Link>
          </div>
        </div>
      </section>

      <section className="sync-section" aria-labelledby="learning-paths-heading">
        <div className="sync-shell">
          <div className="sync-section-heading">
            <p className="sync-kicker">Learning paths</p>
            <h2 id="learning-paths-heading">From understanding the idea to delivering the system.</h2>
          </div>
          <div className="sync-pillar-grid">
            {learningPaths.map(([title, text], index) => (
              <article className="sync-card sync-pillar-card" key={title}>
                <span className="sync-card-number">0{index + 1}</span>
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="sync-section sync-method-section" aria-labelledby="academy-model-heading">
        <div className="sync-shell sync-method-grid">
          <div className="sync-section-heading">
            <p className="sync-kicker">Delivery formats</p>
            <h2 id="academy-model-heading">A learning model that can fit the audience.</h2>
          </div>
          <ol className="sync-method-list">
            <li><span>01</span><div><h3>Institution programs</h3><p>Structured workshops or project-based learning designed with an education partner.</p></div></li>
            <li><span>02</span><div><h3>Team enablement</h3><p>Focused sessions that help working teams adopt useful tools, workflows, and delivery practices.</p></div></li>
            <li><span>03</span><div><h3>Early-career learning</h3><p>Practice-led foundations that help learners connect technical concepts to real project work.</p></div></li>
          </ol>
        </div>
      </section>

      <section className="sync-section sync-final-cta">
        <div className="sync-shell sync-final-cta-inner">
          <p className="sync-kicker">Programs vary by audience and schedule.</p>
          <h2>Tell us who you want to equip and what they need to be able to do.</h2>
          <Link className="sync-button" to="/contact?intent=academy">Discuss an Academy program</Link>
        </div>
      </section>
    </main>
  );
}
